/**
 * 提案通知（査定・投資）の push body は propally_api 側で固定文言として送られている
 * （concern_agent/assessment_proposal_concern.rb, investment_proposal_concern.rb,
 * registration_completion_investment_proposal_job.rb, scheduled_proposal_delivery_service.rb）。
 * 通知種別の判定は「"投資"/"査定" を含むか」ではなく、この文言と完全一致するかで行う。
 * 部分一致にすると、学習記事通知など他機能の自由入力本文がたまたま「投資」「査定」を
 * 含んだだけで提案通知として誤って計測されてしまう
 */
export const ASSESSMENT_PROPOSAL_PUSH_MESSAGE = "認定プランナーから新しい査定提案が届きました！";
export const INVESTMENT_PROPOSAL_PUSH_MESSAGE = "認定プランナーから新しい投資提案が届きました！";

// 通知内容の正規化（受信/タップ計測・種別判定で共通利用）
export const normalizeNotificationText = (v: unknown): string =>
  (typeof v === "string" ? v : String(v ?? "")).normalize("NFKC").toLowerCase().trim();

export type NotificationCategory = "journal" | "assessmentProposal" | "investmentProposal" | null;

/**
 * 通知の route / body（未正規化でよい）から種別を判定する。受信・タップ計測の両方で使う。
 * journal は route ベース、査定・投資提案は body の完全一致で判定する。
 *
 * capacitorLogic.ts / NotificationRouter.tsx から使われるが、capacitorLogic.ts は
 * ESM 専用の @awesome-cordova-plugins/adjust に依存しておりユニットテストの実行環境
 * （Jest）でロードできないため、この判定ロジックだけプラグイン依存の無いこのファイルに切り出す
 */
export const classifyNotificationCategory = (rawRoute: unknown, rawBody: unknown): NotificationCategory => {
  const route = normalizeNotificationText(rawRoute);
  const body = normalizeNotificationText(rawBody);

  if (route.includes("journal")) return "journal";
  if (body === normalizeNotificationText(ASSESSMENT_PROPOSAL_PUSH_MESSAGE)) return "assessmentProposal";
  if (body === normalizeNotificationText(INVESTMENT_PROPOSAL_PUSH_MESSAGE)) return "investmentProposal";
  return null;
};
